import { CANTRATE_ID } from '@webapp/common/resources/constants';

import type { QuestionActor, QuestionContext } from '@webapp/survey/src/machine/question-machine';

import { excludeHiddenAnswers } from '../../machine/helpers/logic';
import type { AnswersRequest } from '../queries-api';

import { QuestionSimpleApi } from './common/simple';

const checkValue = (val: any) => (typeof val === 'number' ? true : Boolean(val));

export class KanoApi extends QuestionSimpleApi {
    public query(actor: QuestionActor): AnswersRequest {
        const { id, answersActors, responseActor } = actor.getSnapshot().context;
        const { comment } = responseActor.getSnapshot().context;

        return {
            comment,
            question: id,
            data: excludeHiddenAnswers(answersActors).flatMap((answerActor) => {
                const { id: answerId, response } = answerActor.getSnapshot().context;
                const { value: functional, extra: dysfunctional, comment } = response.getSnapshot().context;

                if (functional === CANTRATE_ID) {
                    return [
                        {
                            answer: answerId,
                            bool: true,
                            comment: null,
                            cantRate: true,
                        },
                    ];
                }

                return [
                    {
                        bool: true,
                        answer: answerId,
                        comment,
                        cantRate: undefined,
                        json: [
                            { type: 'func', value: functional },
                            { type: 'disfunc', value: dysfunctional },
                        ],
                    },
                ];
            }),
        };
    }

    public validate({
        answersActors: answersActorsRaw,
        params: { required, commentRequired },
    }: QuestionContext): boolean {
        if (required) {
            const answersActors = excludeHiddenAnswers(answersActorsRaw);
            answersActors.forEach((answerActor) => {
                const a = answerActor.getSnapshot().context;
                const response = a.response.getSnapshot().context;
                const valid =
                    response.value === CANTRATE_ID
                        ? true
                        : checkValue(response.value) &&
                          checkValue(response.extra) &&
                          (commentRequired ? checkValue(response.comment) : true);
                answerActor.send({ type: 'SET_VALID', value: valid });
            });

            return answersActors.every((answerActor) => {
                const { response } = answerActor.getSnapshot().context;
                const { value, extra, comment } = response.getSnapshot().context;

                return value === CANTRATE_ID
                    ? true
                    : checkValue(value) && checkValue(extra) && (commentRequired ? checkValue(comment) : true);
            });
        }

        return true;
    }
}
